import React, { memo } from 'react';
import styles from './LogOut.module.less';
import DEFAULT from '../../static/uninstall_logout.svg';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { logging, logPostInfo } from '../../actions/log';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

export default memo(() => {
  const logInfoData = useSelector(selectLogInfo);
  const dispatch = useDispatch();
  const handelLogin = () => {
    dispatch(
      logging({
        category: 'C',
        action: 'Mysoft_Batch_Login',
        label: '',
        param2: {
          source: 'Mysoft_Batch',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
    window && window.CallNativeMethod && window.CallNativeMethod('login');
  };
  return (
    <div className={styles.page_container}>
      <div className={styles.info}>
        <img src={DEFAULT} />
        <div>登录后查看历史安装应用</div>
        <div className={styles.btn} onClick={handelLogin}>
          立即登录
        </div>
      </div>
    </div>
  );
});
